<script setup lang="ts">
import SvgLoader from '@/utils/SvgLoader.vue';
import { computed, ref, StyleValue } from 'vue';
import { getRandomStr } from '@/businessRepository/idUtils';
import { BUSINESS_ROW_MENU_ITEMS } from '../../constants/';
import { i18n } from '@/i18n';
import Mdi from '@/corePagesModule/components/Mdi.vue';

const props = defineProps<{ isOrderMode?: boolean; isAggregateBusiness?: boolean; disabled?: boolean; toolTipMessage?: string }>();

/** Emits */
const emits = defineEmits<{
  (e: 'select', option: (typeof BUSINESS_ROW_MENU_ITEMS)[number]['value']): void;
}>();

/** Variables */
const t = i18n.t;
const containerId = getRandomStr(16);
const isMenuOpenedState = ref<boolean>(false);
const businessRowMenuButtonPosition = ref({
  x: 0,
  y: 0,
});

const items = computed(() => BUSINESS_ROW_MENU_ITEMS.filter((item) => !item.isAggregateOnly || props.isAggregateBusiness));

/** Function */
/**
 * ボタンクリック時orモーダル外をクリックした際の処理
 */
const onClickButton = () => {
  if (!isMenuOpenedState.value) {
    const buttonContent = document.getElementById(containerId);
    const bodyContent = document.getElementsByTagName('body')[0];
    if (!(buttonContent instanceof HTMLElement) || !(bodyContent instanceof HTMLElement)) return;
    businessRowMenuButtonPosition.value = {
      x: buttonContent.offsetWidth,
      y: buttonContent.getBoundingClientRect().top,
    };
  }
  isMenuOpenedState.value = !isMenuOpenedState.value;
};

const tableHeaderModifyMenuStyle = computed((): StyleValue => {
  return {
    top: `${businessRowMenuButtonPosition.value.y + 20}px`,
    right: `${businessRowMenuButtonPosition.value.x}px`,
  };
});
/**
 * 選択肢を選んだ際の処理
 * @param value - 選択した値
 */
const selectOption = (value: (typeof BUSINESS_ROW_MENU_ITEMS)[number]['value']) => {
  isMenuOpenedState.value = false;
  emits('select', value);
};
</script>
<template>
  <div
    :id="containerId"
    v-tooltip.bottom="toolTipMessage"
    class="table-row-menu__button__container"
    :class="{ 'not-allow-cursor': disabled }"
  >
    <button
      class="table-row-menu__button"
      :class="{ 'table-row-menu__button--active': isMenuOpenedState, 'disabled-event': disabled }"
      @click="onClickButton"
    >
      <SvgLoader class="table-row-menu__icon" name="menuEllipsis" />
    </button>
  </div>
  <Teleport v-if="isMenuOpenedState" to="body">
    <div class="table-row-menu__bg" @click="onClickButton" />
    <div class="table-row-menu__dropdown" :style="tableHeaderModifyMenuStyle">
      <div
        v-for="option in items"
        :key="option.value"
        v-tooltip.bottom="isOrderMode && !option.isAvailableInOrderMode && t('発注表示時は使用できません')"
        class="table-row-menu__content"
        :class="isOrderMode && !option.isAvailableInOrderMode && 'not-allow-cursor'"
      >
        <button
          :class="
            isOrderMode && option.value === 'editTransaction'
              ? 'table-row-menu__option table-row-menu__option--disabled disabled-event'
              : 'table-row-menu__option table-row-menu__option--active'
          "
          @click="selectOption(option.value)"
        >
          <Mdi v-if="!!option.isMdi" :icon="option.icon" variant="outlined" class="table-row-menu__icon" />
          <SvgLoader v-else class="table-row-menu__icon" :name="option.icon" />
          <div class="table-row-menu__option--text">{{ t(option.text) }}</div>
        </button>
      </div>
    </div>
  </Teleport>
</template>
<style lang="scss" scoped>
@import '@/InventoryControlModule/pages/scss/inventory-table.scss';
</style>
